import React from "react";
import {
  View,
  Linking,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
} from "react-native";
import { Text, Error, Header, ImgIcon, Loading, InputLabel } from "components";

import { colors, patterns, sizes, strings } from "assets/constants";
import { useContactUs } from "clients/apis";
import { mq } from "utils";
import css from "styles";
import { _callTo, _mailTo, _openLink } from "routers/helper";

const RowInfo = (props: { title: string; value: string }) => {
  const { title, value } = props;

  const _onValuePress = () => {
    if (value.match(patterns.tel)) {
      _callTo(value);
      return;
    }

    if (value.match(patterns.email)) {
      _mailTo(value);
      return;
    }

    if (value.match(patterns.url)) {
      _openLink(value);
      return;
    }
  };

  return (
    <View
      style={{
        ...css.rRow,
        marginBottom: mq(10),
        marginLeft: sizes.space,
      }}
    >
      <View style={{ width: mq(120) }}>
        <Text color={colors.textColorGray} style={{ marginLeft: sizes.space }}>
          {title}:
        </Text>
      </View>
      <View style={css.container}>
        <TouchableOpacity
          onPress={_onValuePress}
          activeOpacity={0.7}
          style={{ alignSelf: "flex-end" }}
        >
          <Text weight="medium" style={{ lineHeight: mq(24) }}>
            {props?.value}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default function ContactUs() {
  const { data, isLoading, isError, error, refetch } = useContactUs();
  const contactUsInfos = data?.data?.contactUsInfo;
  const contactAddresses = data?.data?.contactAddresses;
  const socialNetworks = data?.data?.socialNetworks;

  const _onGoToSocial = (url: string) => Linking.openURL(url);

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return <Error reset={refetch} />;
    }

    return (
      <>
        {contactUsInfos?.length > 0 && (
          <View style={{ marginBottom: sizes.space * 2 }}>
            <InputLabel label={strings.call_ways} />
            {contactUsInfos?.map(
              (info: { name: string; value: string }, key: number) => (
                <RowInfo
                  key={String(key)}
                  title={info.name}
                  value={info.value}
                />
              )
            )}
          </View>
        )}

        {contactAddresses?.length > 0 && (
          <View style={{ marginBottom: sizes.space * 2 }}>
            <InputLabel label={strings.address} />
            {contactAddresses?.map(
              (info: { name: string; value: string }, key: number) => (
                <RowInfo
                  key={String(key)}
                  title={info.name}
                  value={info.value}
                />
              )
            )}
          </View>
        )}

        {socialNetworks?.length > 0 && (
          <>
            <View
              style={{
                width: "100%",
                height: 1,
                backgroundColor: colors.white,
                marginBottom: mq(30),
              }}
            />
            {/* <View style={styles.socialsSectionTopBorder}>
              <View
                style={{
                  width: '100%',
                  height: mq(1),
                  backgroundColor: colors.white,
                  borderRadius: 10,
                }}
              /> 
            </View>*/}
            <View style={styles.socialsContainer}>
              {socialNetworks.map(
                (
                  social: { image: string; value: string; type: string },
                  key: number
                ) => (
                  <TouchableOpacity
                    activeOpacity={sizes.tapOpacity}
                    onPress={() => social.value && _onGoToSocial(social.value)}
                    key={String(key)}
                    style={styles.socialBox}
                  >
                    <ImgIcon size={"70%"} icon={{ uri: social?.image }} />
                  </TouchableOpacity>
                )
              )}
            </View>
          </>
        )}
      </>
    );
  };

  return (
    <>
      <Header title={strings.contact_us} />
      <ScrollView
        contentContainerStyle={{
          ...css.paddingH,
          ...css.growContainer,
          paddingVertical: sizes.space,
        }}
      >
        {_renderContent()}
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  socialsContainer: {
    ...css.rRow,
    ...css.wrap,
    ...css.centralElements,
  },

  socialBox: {
    width: "20%",
    maxWidth: 80,
    aspectRatio: 1,
    borderWidth: 1,
    borderColor: colors.white,
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.lightButtons,
    elevation: 1,
    ...css.centralElements,
    marginTop: sizes.space,
    marginHorizontal: sizes.space / 2,
  },

  socialsSectionTopBorder: {
    height: 3,
    width: "100%",
    elevation: 1,
    borderRadius: 10,
    marginBottom: mq(15),
    backgroundColor: colors.lightButtons,
    justifyContent: "flex-end",
  },
});
